import React, { useEffect, useState, useRef, useMemo } from "react";
import styles from "./lp.styles";
import { useAuth } from "../contextAPI/AuthContext";
import { useNavigate } from "react-router-dom";
import '../../components/landing-page/lp.css'

const CountdownTimer = React.memo(() => {
    const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const intervalRef = useRef(null);
    const nav = useNavigate()
    const { checkToken } = useAuth()
    const calculateTimeLeft = () => {
        const difference = new Date("2024-12-31") - new Date();
        if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / (1000 * 60)) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            setCountdown({ days, hours, minutes, seconds });
        } else {
            clearInterval(intervalRef.current);
        }
    };

    useEffect(() => {
        calculateTimeLeft();
        intervalRef.current = setInterval(calculateTimeLeft, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);

    const countdownDisplay = useMemo(() => (
        <div className="countdown" style={styles.countdown}>
            <div style={styles.time}>{countdown.days}</div><span className="text-shadow" style={{ color: "white" }}>:</span>
            <div style={styles.time}>{countdown.hours}</div><span className="text-shadow" style={{ color: "white" }}>:</span>
            <div style={styles.time}>{countdown.minutes}</div><span className="text-shadow" style={{ color: "white" }}>:</span>
            <div style={styles.time}>{countdown.seconds}</div>
        </div>
    ), [countdown]);

    return (
        <div className="right-section" style={styles.rightSection}>
        </div>
    );
});

export default CountdownTimer;
